export default {
  title: '4 dernières semaines',
  item_interval: '(1)[1 visite];(2)[2 visites];(3-5)[3 à 5 visites];(6-inf)[6+ visites];',
  total: 'Total des visiteurs',
};
